
import { Component, Vue } from "vue-property-decorator";
import { PDropDownContainer } from "@/common/components";
import SupportDropDownStatus from "./SupportDropDownStatus.vue";
import { PRow } from "@/common/components/look/PRow";
import PIcon from "@/common/components/look/PIcon/PIcon.vue";

@Component({
  name: "support-status-filter",
  components: {
    PRow,
    PIcon,
    PDropDownContainer,
    SupportDropDownStatus,
  },
})
export default class SupportStatusFilter extends Vue {}
